<ng-container *ngIf="chargeRequest && !loading">
    <div dwRow>
        <div dwCol="12">
            <div><span class="label">Pilexos Booking Fee: </span><span>{{chargeRequest?.amount || 50 | currency}}</span>
            </div>
            <div *ngIf="paymentDiscountResult?.IsValid">
                <span class="label">Discount Amount: </span><span>{{ paymentDiscountResult?.FinalDiscountAmount |
                    currency }}</span><br>
                <span class="label">Payment Amount: </span><span>{{ paymentDiscountResult?.FinalAmount |
                    currency}}</span>
            </div>
            <div *ngIf="additionalMessage && !showPaymentParty">
                <span>Payment will be charged when your Examiner accepts the checkride.</span>

                <span>Note: {{additionalMessage}}</span>
            </div>
        </div>
    </div>
    <div dwRow>
        <div dwCol="12">
            <label class="label">Discount Code</label>
            <input type="text" class="form-control" [(ngModel)]="chargeRequest.paymentDiscountCode"
                (ngModelChange)="onChange()" />
            <button (click)="applyDiscountCode()" class="btn btn-primary">Apply</button>

            <div *ngIf="paymentDiscountResult"
                [ngClass]="{ 'dw-red': !paymentDiscountResult.IsValid , 'dw-green': paymentDiscountResult.IsValid }">
                {{paymentDiscountResult.Message}}
            </div>
        </div>
    </div>
    <ng-container *ngIf="paymentDiscountResult?.FinalAmount !== 0">
        <div dwRow *ngIf="showPaymentParty">
            <div dwCol="12">
                <label>
                    <br>
                    <span class="pilexos-checkbox">
                        <input type="checkbox" [(ngModel)]="payWithApplicantCard" (ngModelChange)="changePartyType()">
                        <span>Pay with Applicant Credit Card</span>
                    </span>
                </label>
                <br>
            </div>
        </div>
        <div dwRow *ngIf="showCardSelection && !payWithApplicantCard && customer?.PaymentCard?.length > 0">
            <div dwCol="12">
                <label class="label">Use Saved Card</label>
                <select class="form-control" [(ngModel)]="chargeRequest.cardDetails.cardReferenceKey"
                    (ngModelChange)="onChange()">
                    <option [ngValue]="null">Enter Card Information</option>
                    <option *ngFor="let card of customer?.PaymentCard" [ngValue]="card.CardReferenceKey">
                        {{card.CardName}}</option>
                </select>
            </div>
        </div>
        <ng-container *ngIf="!showCardSelection || !chargeRequest.cardDetails.cardReferenceKey">
            <app-payment-card-details [(cardDetails)]="chargeRequest.cardDetails"
                [showAddTestCardInfo]="showAddTestCardInfo" (cardDetailsChange)="onChange()"></app-payment-card-details>
          
            <div dwRow *ngIf="showCardSelection && !payWithApplicantCard">
                <div dwCol="6">
                    <label>
                        <span class="pilexos-checkbox">
                            <input type="checkbox" [(ngModel)]="chargeRequest.addCardToCustomer"
                                (ngModelChange)="onChange()">
                            <span>Save card for later</span>
                        </span>
                    </label>
                </div>
                <div dwCol="6" *ngIf="chargeRequest.addCardToCustomer">
                    <label>
                        <span class="pilexos-checkbox">
                            <input type="checkbox" [(ngModel)]="chargeRequest.markDefaultCard"
                                (ngModelChange)="onChange()">
                            <span>Set as Default</span>
                        </span>
                    </label>
                </div>
            </div>
        </ng-container>
        <div dwRow>
            <div dwCol="12">
                <label class="label">CC E-mail Receipt</label>
                <input type="text" class="form-control" [(ngModel)]="chargeRequest.EmailCCReceipt"
                    (ngModelChange)="onChange()" />
            </div>
        </div>
    </ng-container>
</ng-container>